import { render, staticRenderFns } from "./busMobileComponent.vue?vue&type=template&id=6a10c361&scoped=true&"
import script from "./busMobileComponent.vue?vue&type=script&lang=js&"
export * from "./busMobileComponent.vue?vue&type=script&lang=js&"
import style0 from "./busMobileComponent.vue?vue&type=style&index=0&id=6a10c361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10c361",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VChip,VChipGroup,VCol,VRow,VTooltip})
